import { render, staticRenderFns } from "./callData.vue?vue&type=template&id=7afa3004&scoped=true&"
import script from "./callData.vue?vue&type=script&lang=js&"
export * from "./callData.vue?vue&type=script&lang=js&"
import style0 from "./callData.vue?vue&type=style&index=0&id=7afa3004&prod&lang=scss&scoped=true&"
import style1 from "./callData.vue?vue&type=style&index=1&id=7afa3004&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afa3004",
  null
  
)

export default component.exports